module.exports = __webpack_public_path__ + "static/media/design-illustration-2.f07a650d.svg";